export const SAGA_TITLE = 'phone' // TODO: use real one
export const SAGA_ID = '8108550619457' // TODO: use real one
export const IMAGE_FALLBACK = '/saga.png' // TODO: use real one

export const COLORS = {
  ceramic_black: '#000',
  purple: '#8752F3',
}
